export function getStatsAndReportsUrl (env: Partial<ImportMetaEnv>): string {
  let url = ''

  if (env.VUE_APP_STATS_AND_REPORTS_URL) {
    // shortcut: force stats & reprots url from env.
    url = env.VUE_APP_STATS_AND_REPORTS_URL
  } else {
    url = window.location.origin.replace('://', '://stats-and-reports.')
  }

  return url.replace(/\/+$/, '')
}
